export function isEmptyObject(object: object): boolean {
  let isEmpty = true;
  if (object && Object.entries(object).length > 0) {
    Object.entries(object).forEach(([key, value]) => {
      if (value) isEmpty = false;
    });
  }
  return isEmpty;
}

export function getSomeObjectKeyEntries(data: object, keys: string[]) {
  return getObjectKeyEntries(data).filter((el) => keys.includes(el));
}

export function getObjectKeyEntries(data: object): string[] {
  const entries: string[] = [];

  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      if (value) entries.push(key);
    });
  }

  return entries;
}

export const cleanHttpParamsInputObject = (x: object) => {
  const entries = Object.entries(x ?? {})
    .filter(([_, value]) => (value && value?.length) || Number.isInteger(value))
    .map(([key, el]) => [key, Array.isArray(el) ? el.join(",") : el]);

  return Object.fromEntries(entries);
};
